import { useApiStatus } from '@/hooks/use-api-status'
import { api } from '@/api/client'

interface OfflineState {
  /** Whether the client is currently offline. */
  isOffline: boolean
  /** Number of mutations waiting to be synced. */
  pendingCount: number
  /** Whether mutations are currently being replayed. */
  isSyncing: boolean
  /** Whether the last data fetch was served from cache. */
  isCachedData: boolean
  /** Whether the session is dead and needs re-auth. */
  sessionDead: boolean
  /** Whether we're in read-only mode (grace expired). */
  readOnly: boolean
  /** Clear all cached API responses. */
  clearCache: () => void
  /** Clear the mutation queue (discards all pending). */
  clearQueue: () => void
}

/**
 * Convenience hook for pages that want to display offline state.
 * Wraps the api status fields with friendlier names.
 */
export function useOffline(): OfflineState {
  const status = useApiStatus()

  return {
    isOffline: !status.connected,
    pendingCount: status.pendingSync,
    isSyncing: status.syncing,
    isCachedData: status.lastCacheHit,
    sessionDead: status.sessionDead,
    readOnly: status.readOnly,
    clearCache: () => api.offlineStore.clearCache(),
    clearQueue: () => api.syncQueue.clear(),
  }
}
